import React from "react";
import axios from "axios";
import { Button, Box } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { SoftwareLog } from "../../../models/SoftwareLogModel";
import { WithTranslation, withTranslation } from "react-i18next";
import { addNotification } from "../../../utils/NotificationHandler";
import { moduleTypes } from "acr-common-models";

interface IDownloadProps extends WithTranslation {
  logType: "watermarkLog" | "softwareLog" | "qualityIndexLog" | "maintenance/log/snap" | "maintenance/log/ink" | "maintenance/log/software" | "maintenance/backup";
  channelId?: number;
  logLevel?: number;
  orderType?: "desc" | "asc";
  orderBy?: keyof SoftwareLog;
  encodedSearchQuery?: string;
  categoryName?: string[];
  unmargined?: boolean;
  technology?: "snap" | "ink";
  checkCount?: boolean;
}

class Download extends React.Component<IDownloadProps> {
  private aRef: React.RefObject<HTMLAnchorElement> = React.createRef();
  private disabled: boolean = false;

  private buildHref(countOnly:boolean = false): string {
    const props = this.props as IDownloadProps;
    let params = [];
    if (props.channelId) {
      params.push(`channelId=${props.channelId}`);
    }
    if (props.logLevel) {
      params.push(`level=${props.logLevel}`);
    }
    if (props.encodedSearchQuery && props.encodedSearchQuery.length > 0) {
      params.push(`searchQuery=${props.encodedSearchQuery}`);
    }
    if (props.orderBy) {
      params.push(`orderBy=${props.orderBy}`);
    }
    if (props.orderType) {
      params.push(`orderType=${props.orderType}`);
    }
    if (props.technology) {
      params.push(`technology=${props.technology}`);
    }
    if (props.categoryName) {
      const categoryList: Array<number | undefined> = props.categoryName.map(
        (category) => moduleTypes.find((moduleType) => category === moduleType.title)?.id
      );
      for (var i=0; i< categoryList.length; i++) {
        params.push("moduleTypes="+categoryList[i]);
      }
    }    
    let href = "";
    if (countOnly)
    {
       href = `/${props.logType}/count`;
    }
    else
    {
      params.push(`authorization=Bearer ${localStorage.getItem("access_token")}`);
      href = `${axios.defaults.baseURL}/${props.logType}/download`;
      href = href.replace(":3000/api", ":3100/api"); // FCTODO remove when dev proxy supports streaming
    }
    if (params.length) {
      href += "?" + params.join("&");
    }
    return href;
  }
  

  //NOTE: Before we click on the 'download' link, we check the presence of the log with /count
  private checkCount = async() : Promise<boolean>=> {
    return await axios
      .get(this.buildHref(true))
      .then((response) => {
        if (response.data?.count > 0)
          return true;
        else
          return false;
      })
      .catch((e) => {
        console.log(e);
        return false;
      });
  }

  private onClick = async (e: any) => {
    const { t } = this.props;
    const props = this.props as IDownloadProps;
    const element = this.aRef.current;
    if (!element) {
      return;
    }
    // TODO disable the download button when no log are displayed (wrong filter, or empty category, or...)
    // if (this.props.categoryName && this.props.categoryName.length === 0) {
    //   // No category: no log
    //   return;
    // }
    if (props.checkCount)
    {
      const filesExist = await this.checkCount();
      if (!filesExist)
      {
        addNotification(t("No logs found"));
        return;
      }
    }
    element.href = this.buildHref();
    element.click();
    this.disabled = true;
    addNotification(t("Download in progress"));
    setTimeout(() => {
      this.disabled = false;
    }, 5000);
  };

  public render(): React.ReactElement {
    const { t } = this.props;
    return (
      <Box sx={{ margin: !this.props.unmargined ? "18px 2em 0 auto": "", paddingTop: !this.props.unmargined ? "16px" : "0px" }}>
        <Button data-cy="download-button" variant="contained" color="primary" onClick={this.onClick} disabled={this.disabled}>
          <GetAppIcon />
          {t("Download")}
        </Button>
        <a ref={this.aRef} href="./" style={{ display: "none" }} target="_blank" download="error">
          Link
        </a>
      </Box>
    );
  }
}

export const translatedDownload = withTranslation()(Download);
export { translatedDownload as Download };
